document.addEventListener('DOMContentLoaded', function() {
    // Select only the inputs with name "Total Carat Weight"
    const caratWeightInputs = document.querySelectorAll('input[name="Total Carat Weight"]');
    const selectedTotalCaratWeight = document.getElementById('selected-total-carat-weight');

    // Function to set default value on page load
    function setDefaultCaratWeight() {
        const defaultInput = document.querySelector('input[name="Total Carat Weight"]:checked');
        if (defaultInput) {
            selectedTotalCaratWeight.textContent = defaultInput.value;
        }
    }

    // Run the default function on page load
    setDefaultCaratWeight();

    // Add event listeners to each input
    caratWeightInputs.forEach(input => {
        input.addEventListener('click', function() {
            // Get the value of the clicked radio button
            const totalCaratWeight = this.value;

            // Update the display with the selected value
            selectedTotalCaratWeight.textContent = totalCaratWeight;

            // Optional: Add an 'active' class to the corresponding label
            document.querySelectorAll('.product-form__label').forEach(label => label.classList.remove('active'));
            const associatedLabel = document.querySelector(`label[for="${this.id}"]`);
            if (associatedLabel) {
                associatedLabel.classList.add('active');
            }
        });
    });
});